import { Controller } from "stimulus"
import { EventTrackerService } from "../services/event_tracker_service"

export default class extends Controller {
  connect() {
    this.eventTracker = new EventTrackerService();
    this.eventTracker.initialize();
  }

  track(e) {
    const element = e.currentTarget;

    // One-shot by default (matches the original navigation-link use case). An
    // element that stays on the page across multiple real interactions (tabs,
    // filter chips, a modal trigger reopened after a cancel) opts in via
    // data-event-allow-repeat so a genuine second click isn't silently dropped —
    // but still needs its own guard against a plain accidental double-click/
    // double-tap, which the removed one-shot latch happened to catch too. A short
    // cooldown does both: blocks clicks milliseconds apart, allows ones seconds
    // or minutes apart.
    const repeatCooldownMs = 500;
    const now = Date.now();
    const lastTrackedAt = Number(element.dataset.eventLastTrackedAt || 0);

    if (element.dataset.eventTracked) {
      if (element.dataset.eventAllowRepeat !== "true") return;
      if (now - lastTrackedAt < repeatCooldownMs) return;
    }

    element.dataset.eventTracked = "true";
    element.dataset.eventLastTrackedAt = String(now);

    const eventName = element.dataset.eventName;
    let properties = {};

    try { properties = JSON.parse(element.dataset.eventProperties || "{}"); } catch (e) { console.error("[EventTracker] Failed to parse eventProperties:", e); }

    if (element.dataset.eventFormFields) {
      try {
        const formFields = JSON.parse(element.dataset.eventFormFields);
        for (const [prop, selector] of Object.entries(formFields)) {
          const input = document.querySelector(selector);
          if (input) properties[prop] = input.value;
        }
      } catch (e) { console.error("[EventTracker] Failed to parse eventFormFields:", e); }
    }

    if (element.dataset.eventAttributeFields) {
      try {
        const attributeFields = JSON.parse(element.dataset.eventAttributeFields);
        for (const [prop, attribute] of Object.entries(attributeFields)) {
          properties[prop] = element.getAttribute(attribute);
        }
      } catch (e) { console.error("[EventTracker] Failed to parse eventAttributeFields:", e); }
    }

    this.eventTracker.trackEvent(eventName, properties, element);
  }
}
